import React from "react";
import { Link, NavLink} from "react-router-dom";
const Nav = ({display, setDisplay}) => {

  const displayHandler = () =>{
    if (setDisplay) {
      setDisplay(!display)
    }
  }

  return (
    // <BrowserRouter>
    <nav className="flex items-stretch bg-[rgba(255,255,255,.98)]
     bottom-0 shadow-[0_-1px_2px_0_rgba(0,0,0,.12)]
     h-[56px] left-0 w-[100%] z-50 fixed
     "
    >
        <NavLink to="/" className="navItem sm:flex-row whitespace-break-spaces">
         <label className="text-[#cf9816] text-[15px] font-[800]  hidden md:block text-right">دیوار دیل</label> 
      <span className="text-[#db6666]  px-[10px] font-[600] md:text-[17px] text-[15px] text-center">
        آگهی ها
      </span>
        </NavLink>

        <NavLink to="/cat" className="navItem md:flex-row font-[600] text-[17px] text-[#db6666]" onClick={displayHandler}> دسته ها 
      <span className="pt-[10px] md:pt-0">
        <svg className="text-[1.5rem] ml-[8px]" viewBox="0 0 600 600" version="1.1" width="20px" height="20px" xmlns="http://www.w3.org/2000/svg" fill="#505050" transform="matrix(-1, 0, 0, 1, 0, 0)"><g id="SVGRepo_bgCarrier" strokeWidth="0" /><g id="SVGRepo_tracerCarrier" /><g><defs  /><g  transform="matrix(0.95173205,0,0,0.95115787,13.901174,12.168794)"><g transform="matrix(1.3807551,0,0,1.2700888,273.60014,263.99768)" /> <g transform="matrix(1.5092301,0,0,1.3955555,36.774048,-9.4503933)" /> <path d="m 116.82051,533.90848 c 0,-35.77923 -30.001428,-65.78273 -65.71225,-65.78274 -35.710867,10e-6 -65.714445,30.00351 -65.714445,65.78274 0,35.7791 30.003578,65.78265 65.714445,65.78265 35.710822,0 65.71225,-30.00355 65.71225,-65.78265 z" id="path1237" /><path d="m 116.82051,302.6125 c 0,-35.77918 -30.001428,-65.78266 -65.71225,-65.78267 -35.710867,1e-5 -65.714445,30.00349 -65.714445,65.78267 2.6e-5,35.77922 30.003597,65.78043 65.714445,65.78045 35.710806,-2e-5 65.71224,-30.00123 65.71225,-65.78045 z" id="path1235" /><path d="m 116.82051,71.313209 c 0,-35.779199 -30.001428,-65.7804582 -65.71225,-65.7804662 -35.710867,8e-6 -65.714445,30.0012672 -65.714445,65.7804662 0,35.779271 30.003578,65.782741 65.714445,65.782751 35.710822,-1e-5 65.71225,-30.00348 65.71225,-65.782751 z" id="path346"/><path d="m 211.58808,21.527961 a 47.572886,49.785578 0 0 0 -47.57256,49.787552 47.572886,49.785578 0 0 0 47.57256,49.785227 H 568.24859 A 47.572886,49.785578 0 0 0 615.82336,71.315513 47.572886,49.785578 0 0 0 568.24859,21.527961 Z" id="path1011" /> <path d="m 211.58808,252.82616 a 47.572886,49.785578 0 0 0 -47.57256,49.78524 47.572886,49.785578 0 0 0 47.57256,49.78523 h 356.66051 a 47.572886,49.785578 0 0 0 47.57477,-49.78523 47.572886,49.785578 0 0 0 -47.57477,-49.78524 z" id="path1011-7" /><path d="m 211.58808,484.1232 a 47.572886,49.785578 0 0 0 -47.57256,49.78523 47.572886,49.785578 0 0 0 47.57256,49.78524 h 356.66051 a 47.572886,49.785578 0 0 0 47.57477,-49.78524 47.572886,49.785578 0 0 0 -47.57477,-49.78523 z" id="path1011-5"/></g></g></svg> 
      </span>
      </NavLink>

      <Link to="/add" className="navItem md:flex-row font-[600] text-[17px] text-[#db6666] addad">
      ثبت آگهی
      <span className="pt-[10px] md:pt-0">
      <svg className="text-[1.5rem] ml-[8px]"  width="20px" height="20px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12.5 5.5C13.0523 5.5 13.5 5.94772 13.5 6.5V10.5H17.5C18.0523 10.5 18.5 10.9477 18.5 11.5V12.5C18.5 13.0523 18.0523 13.5 17.5 13.5H13.5V17.5C13.5 18.0523 13.0523 18.5 12.5 18.5H11.5C10.9477 18.5 10.5 18.0523 10.5 17.5V13.5H6.5C5.94772 13.5 5.5 13.0523 5.5 12.5V11.5C5.5 10.9477 5.94772 10.5 6.5 10.5H10.5V6.5C10.5 5.94772 10.9477 5.5 11.5 5.5H12.5Z" fill="#505050"/>
</svg>
      </span>
      </Link>


      <NavLink to="/chat" className="navItem md:flex-row font-[600] text-[17px] text-[#db6666]">
       چت 
      <span className="pt-[10px] md:pt-0">
      <svg className="text-[1.5rem] ml-[8px]" width="20px" height="20px" viewBox="0 0 24 24" fill="#505050" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M22 10.787c0 4.854-4.253 8.788-9.5 8.788a10.22 10.22 0 0 1-2.684-.355c-1.881 1.241-4.233 1.617-5.485 1.73-.286.027-.434-.347-.24-.559.595-.65 1.431-1.803 1.715-3.368C4.073 15.43 3 13.225 3 10.787 3 5.934 7.253 2 12.5 2S22 5.934 22 10.787z" fill="#505050"/></svg>
      </span>
       </NavLink>


      <Link to="/my" className="navItem md:flex-row font-[600] text-[17px] text-[#db6666]">
      دیوار من 
      <span className="pt-[10px] md:pt-0">
      <svg className="text-[1.5rem] ml-[8px]" width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="12" cy="6" r="4" fill="#505050"/>
<ellipse cx="12" cy="17" rx="7" ry="4" fill="#505050"/>
</svg>
      </span>
      </Link>



    </nav>
    // </BrowserRouter>
  );
};

export default Nav;
